export const isRecipePinned = recipe => Boolean(recipe?.pinned)

export const countPinnedRecipes = (recipes = []) =>
  (recipes || []).filter(isRecipePinned).length

export const sortPinnedRecipes = (recipes = []) =>
  [...recipes].sort((a, b) => {
    const aTime = a?.pinnedAt ? new Date(a.pinnedAt).getTime() : 0
    const bTime = b?.pinnedAt ? new Date(b.pinnedAt).getTime() : 0
    if (aTime !== bTime) {
      return aTime - bTime
    }
    return String(a?.title || '').localeCompare(String(b?.title || ''))
  })

export const filterPinnedRecipes = (recipes = []) =>
  sortPinnedRecipes((recipes || []).filter(isRecipePinned))
